// @flow

import { deepClone } from "../../../../../utils/helpers";
import DropDownMenu from "./DropDownMenu";

type Props = {
    className: string,
    onChangeValue: Function,
    menu: Array<Object>,
    title?: string,
    isActivityLog?: boolean,
    infoMessage?: string,
    fromQuestionnaire?: boolean,
};

export default function DropdownContainer({
    className,
    onChangeValue,
    infoMessage,
    menu,
    title,
    isActivityLog = false,
    fromQuestionnaire,
}: Props) {
    let choices = deepClone(menu); // choices for the question

    if (!isActivityLog) choices = choices.filter((c) => c.title);
    const selected =
        title ||
        choices?.filter((c) => c.selected === true)[0]?.title ||
        choices[0]?.title;

    const onSelectionChange = (choice: Object) => {
        choices = choices.map((el) => {
            const selectionCondition = isActivityLog
                ? el.value === choice.value
                : el.id === choice.id;

            if (selectionCondition) {
                if (!isActivityLog) el.value = choice.title;
                el.selected = true;
            } else {
                if (!isActivityLog) el.value = null;
                el.selected = false;
            }

            return el;
        });
        onChangeValue(choices);
    };

    return (
        <DropDownMenu
            className={`${className}`}
            title={selected}
            onChangeValue={onSelectionChange}
            infoMessage={infoMessage}
            isActivityLog={isActivityLog}
            menu={choices}
            fromQuestionnaire={fromQuestionnaire}
        />
    );
}
